
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M42.896 17.575l-17.434-5.356a4.993 4.993 0 00-2.924 0L5.104 17.575c-1.472.452-1.472 2.398 0 2.85l3.039.933a4.925 4.925 0 00-1.118 2.931C6.424 24.634 6 25.257 6 26c0 .674.355 1.24.866 1.603l-1.596 7.18A1 1 0 006.246 36h3.507a1 1 0 00.976-1.217l-1.595-7.18c.51-.362.866-.93.866-1.603 0-.723-.405-1.328-.979-1.68a2.948 2.948 0 011.293-2.294l12.223 3.755c.567.174 1.653.39 2.925 0l17.434-5.356c1.472-.453 1.472-2.398 0-2.85zM26.049 27.693a6.997 6.997 0 01-4.1 0l-9.063-2.784L12 32c0 2.21 5.372 4 12 4 6.627 0 12-1.79 12-4l-.886-7.092-9.065 2.785z","fill":"#535353","fill-rule":"nonzero"}})])
          )
        }
      }
    